/**
 * Mesh helpers for group voice rooms.
 * New joiner offers to every existing peer; peers answer.
 */

export const toSessionDescription = (value, fallbackType) => {
  if (!value) {
    return null;
  }
  if (typeof value === 'string') {
    return { type: fallbackType, sdp: value };
  }
  if (value.type && value.sdp) {
    return { type: value.type, sdp: value.sdp };
  }
  return null;
};

export const attachStreamTracks = (pc, stream) => {
  if (!pc || !stream) {
    return;
  }
  const existing = new Set(
    pc.getSenders().map((sender) => sender.track?.id).filter(Boolean),
  );
  stream.getTracks().forEach((track) => {
    if (!existing.has(track.id)) {
      pc.addTrack(track, stream);
    }
  });
};

export const closeMeshPeer = (pcsMap, pendingIceMap, peerId) => {
  const pc = pcsMap.get(peerId);
  if (pc) {
    try {
      pc.onicecandidate = null;
      pc.ontrack = null;
      pc.onconnectionstatechange = null;
      pc.oniceconnectionstatechange = null;
      pc.close();
    } catch (_) {
      // ignore
    }
    pcsMap.delete(peerId);
  }
  pendingIceMap.delete(peerId);
};

export const closeAllMeshPeers = (pcsMap, pendingIceMap) => {
  Array.from(pcsMap.keys()).forEach((peerId) => {
    closeMeshPeer(pcsMap, pendingIceMap, peerId);
  });
};

export const anyMeshConnected = (pcsMap) => {
  for (const pc of pcsMap.values()) {
    if (
      pc.connectionState === 'connected'
      || pc.iceConnectionState === 'connected'
      || pc.iceConnectionState === 'completed'
    ) {
      return true;
    }
  }
  return false;
};
